import request from '@/config/request'
import CFG from '@/config/config.json'
//查询设备
export const getDeviceByPage = (parames) => {
    return request({
        url: CFG.LOTIP + '/deviceUser/getDeviceByPage?'+parames,
        method: 'get',
    })
}

export const getDeviceTempByPage = (parames) => {
    return request({
        url: CFG.LOTIP + '/deviceUser/getDeviceTempByPage?'+parames,
        method: 'get',
    })
}

export const updateDeviceName = (parames) => {
    return request({
        url: CFG.LOTIP + '/deviceUser/updateDeviceName?'+parames,
        method: 'put',
    })
}

export const updateConfiguration = (parames) => {
    return request({
        url: CFG.LOTIP + '/configuration/updateTemplate',
        method: 'post',
        data: parames
    })
}


export const getDeviceTempById = (id) => {
    return request({
        url: CFG.LOTIP + '/deviceUser/getDeviceTempById?id='+id,
        method: 'get',
    })
}

export const getDeviceTempBySystemSid = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/deviceUser/getDeviceTempBySystemSid?systemSid='+systemSid,
        method: 'get',
    })
}



export const deleteFileByUrl = (url) => {
    return request({
        url: CFG.LOTIP + '/file/deleteFileByUrl?url='+url,
        method: 'delete',
    })
}


export const deleteBackgroundImage = (url,deviceId) => {
    return request({
        url: CFG.LOTIP + '/template/deleteFileByUrl?url='+url+'&deviceId='+deviceId,
        method: 'delete',
    })
}

export const updateTemplate = (parames) => {
    return request({
        url: CFG.LOTIP + '/template/updateTemplate',
        method: 'post',
        data: parames
    })
}


export const importBatchGrasslandType = (systemSid,type,parames) => {
    return request({
        url: CFG.LOTIP + '/grasslandType/importBatch?systemSid='+systemSid+'&type='+type,
        method: 'post',
        data: parames
    })
}

export const importBatchVegetationCoverage = (systemSid,type,parames) => {
    return request({
        url: CFG.LOTIP + '/vegetationCoverage/importBatch?systemSid='+systemSid+'&type='+type,
        method: 'post',
        data: parames
    })
}

export const importBatchGrasslandClass = (systemSid,type,parames) => {
    return request({
        url: CFG.LOTIP + '/grasslandClass/importBatch?systemSid='+systemSid+'&type='+type,
        method: 'post',
        data: parames
    })
}

export const importBatchGrasslandDegradation = (systemSid,type,parames) => {
    return request({
        url: CFG.LOTIP + '/grasslandDegradation/importBatch?systemSid='+systemSid+'&type='+type,
        method: 'post',
        data: parames
    })
}

export const importBatchSteppeTable = (systemSid,type,parames) => {
    return request({
        url: CFG.LOTIP + '/steppeTable/importBatch?systemSid='+systemSid+'&type='+type,
        method: 'post',
        data: parames
    })
}

export const importBatchGrasslandGrade = (systemSid,type,parames) => {
    return request({
        url: CFG.LOTIP + '/grasslandGrade/importBatch?systemSid='+systemSid+'&type='+type,
        method: 'post',
        data: parames
    })
}

export const importBatchPestList = (systemSid,type,parames) => {
    return request({
        url: CFG.LOTIP + '/pestList/importBatch?systemSid='+systemSid+'&type='+type,
        method: 'post',
        data: parames
    })
}

export const importBatchPestInfo = (systemSid,type,parames) => {
    return request({
        url: CFG.LOTIP + '/pestInfo/importBatch?systemSid='+systemSid+'&type='+type,
        method: 'post',
        data: parames
    })
}



export const importBatchPest = (systemSid,parames) => {
    return request({
        url: CFG.LOTIP + '/pest/uploadPest?systemSid='+systemSid,
        method: 'post',
        data: parames
    })
}





// 草地类型
export const getGrasslandTypeList = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/grasslandType/getList?systemSid='+systemSid,
        method: 'get',
    })
}
// 植被盖度
export const getVegetationCoverageList = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/vegetationCoverage/getList?systemSid='+systemSid,
        method: 'get',
    })
}
// 草原级
export const getGrasslandClassList = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/grasslandClass/getList?systemSid='+systemSid,
        method: 'get',
    })
}
// 草原退化
export const getGrasslandDegradationList = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/grasslandDegradation/getList?systemSid='+systemSid,
        method: 'get',
    })
}

// 草地等
export const getSteppeTableList = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/steppeTable/getList?systemSid='+systemSid,
        method: 'get',
    })
}
// 草原等级
export const getGrasslandGradeList = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/grasslandGrade/getList?systemSid='+systemSid,
        method: 'get',
    })
}
// 有害生物名录
export const getPestListList = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/pestList/getList?systemSid='+systemSid,
        method: 'get',
    })
}
// 有害生物信息
export const getPestInfoList = (systemSid,current,size) => {
    return request({
        url: CFG.LOTIP + '/pestInfo/getList?systemSid='+systemSid+"&current="+current+"&size="+size,
        method: 'get',
    })
}

export const updateGrasslandType = (parames) => {
    return request({
        url: CFG.LOTIP + '/grasslandType/updateData',
        method: 'post',
        data: parames
    })
}

export const updateVegetationCoverage = (parames) => {
    return request({
        url: CFG.LOTIP + '/vegetationCoverage/updateData',
        method: 'post',
        data: parames
    })
}

export const updateGrasslandClass = (parames) => {
    return request({
        url: CFG.LOTIP + '/grasslandClass/updateData',
        method: 'post',
        data: parames
    })
}

export const updateGrasslandDegradation = (parames) => {
    return request({
        url: CFG.LOTIP + '/grasslandDegradation/updateData',
        method: 'post',
        data: parames
    })
}

export const updateSteppeTable = (parames) => {
    return request({
        url: CFG.LOTIP + '/steppeTable/updateData',
        method: 'post',
        data: parames
    })
}

export const updateGrasslandGrade = (parames) => {
    return request({
        url: CFG.LOTIP + '/grasslandGrade/updateData',
        method: 'post',
        data: parames
    })
}

export const updatePestList = (parames) => {
    return request({
        url: CFG.LOTIP + '/pestList/updateData',
        method: 'post',
        data: parames
    })
}

export const updatePestInfo = (parames) => {
    return request({
        url: CFG.LOTIP + '/pestInfo/updateData',
        method: 'post',
        data: parames
    })
}


// 有害生物
export const getPestList = (systemSid) => {
    return request({
        url: CFG.LOTIP + '/pest/getList?systemSid='+systemSid,
        method: 'get',
    })
}


export const deleteMediaCapital = (id) => {
    return request({
        url: CFG.LOTIP + '/mediaCapital/deleteFileById?id='+id,
        method: 'delete',
    })
}

export const updateQygw = (parames) => {
    return request({
        url: CFG.LOTIP + '/qygw/updateQygw',
        method: 'post',
        data: parames
    })
}

